import type { DeviceModel } from "@irriga-mais/common";
import { atom } from "jotai";
import { apiService } from "@/api/service";
import { withOperationHandlingAtom } from "../operations";

//The base atom that holds the actual data
const deviceModelDataAtom = atom<DeviceModel[]>([]);
deviceModelDataAtom.debugLabel = "deviceModelDataAtom";

// 2. The "Action" atom to handle fetching
/**
 * Virtual Device Configuration of the selected property.
 * get - returns the cached data
 * set - fetches the data from the API and caches it
 */
export const deviceModelsAtom = atom(
  (get) => get(deviceModelDataAtom), // The "Read" part
  async (get, set) => {
    // The "Write" part
    const result = await set(
      withOperationHandlingAtom,
      {
        operation: "fetchDeviceModels",
        message: "Carregando modelos de dispositivo...",
        displayLoading: true,
        displayError: true,
      },
      async () => {
        const items = await apiService.deviceModel.query({
          fields: ["*"],
        });
        set(deviceModelDataAtom, items);
        return items;
      }
    );

    return result;
  }
);
deviceModelsAtom.debugLabel = "deviceModelsAtom";
